import { MasterEvent, TimeStampModifiers } from "../../../../data";
import { computed } from "mobx";
import { BaseDict } from "../../dict";
import { entities } from "sbtech-sports-data-api-client";

/* istanbul ignore next */
export class TimestampFormatter {
    private masterEvent: MasterEvent;
    private dict: BaseDict;
    constructor(masterEvent: MasterEvent, dict: BaseDict) {
        this.masterEvent = masterEvent;
        this.dict = dict;
    }

    /* istanbul ignore next */
    @computed get modifierDatePeriodTimes(): TimeStampModifiers {
        return this.masterEvent.isLive
            ? TimeStampModifiers.modifierLiveTime
            : TimeStampModifiers.modifierDatePeriod;
    }

    /* istanbul ignore next */
    @computed get modifierTimeScore(): TimeStampModifiers {
        return this.masterEvent.isLive
            ? TimeStampModifiers.modifierScore
            : TimeStampModifiers.modifierTime;
    }

    /* istanbul ignore next */
    @computed get textDatePeriodTime(): string {
        if (this.masterEvent.isLive) {
            if (this.masterEvent.liveStartCountdown > 0) {
                return `${this.dict.StartsIn} ${this.masterEvent.formattedCountdown}`;
            }

            if (this.masterEvent.liveGameState
                && this.masterEvent.liveGameState.gamePart) {
                return `${this.dict[this.masterEvent.liveGameState.gamePart.toString()]}
                ${this.shouldShowTime ? this.masterEvent.liveGameState.formattedTime : ""}`;
            }

            return "";
        }

        return this.masterEvent.eventDate;
    }

    /* istanbul ignore next */
    @computed get textTimeScore(): string {
        if (this.masterEvent.isLive) {
            if (this.masterEvent.liveGameState) {
                return `${this.masterEvent.score1 || ""}-${this.masterEvent.score2 || ""}`;
            }

            return "";
        }

        return this.masterEvent.eventTime;
    }

    @computed get shouldShowTime(): boolean {
        return !this.getInactiveGamesStates()
            .some(status => !!(this.masterEvent.liveGameState
                && this.masterEvent.liveGameState.gamePart
                && this.masterEvent.liveGameState.gamePart === status));
    }

    private getInactiveGamesStates(): entities.GamePart[] {
        return [entities.GamePart.BreakAfterFirstOvertime,
        entities.GamePart.BreakAfterFirstPeriod,
        entities.GamePart.BreakAfterSecondPeriod,
        entities.GamePart.BreakAfterThirdPeriod,
        entities.GamePart.BreakAfterFirstQuarter,
        entities.GamePart.BreakAfterSecondQuarter,
        entities.GamePart.BreakAfterThirdQuarter,
        entities.GamePart.BreakAfterFourthQuarter,
        entities.GamePart.BreakAfterFirstHalf
        ];
    }
}